import { creatorbase } from '@round/api';
import {
    useInfinitePosts,
    InfinitePostsParams as Params,
    InfinitePostsConfig as Config,
} from '@round/creatorbase-helpers/api-hooks';
import { isNotNullOrUndefined } from 'utility/utility';
import uniq from 'lodash/uniq';
import { useTikTokUserStatsCacheByIds } from '@round/platforms/tiktok';
import uniqBy from 'lodash/uniqBy';

export default function usePlatformPosts<
    TIncludePostDetails extends boolean = false,
    TPlatform extends creatorbase.Platform = creatorbase.Platform,
>(params: Params<TIncludePostDetails, TPlatform>, config: Config<TIncludePostDetails, TPlatform> = { enabled: true }) {
    const posts = useInfinitePosts(params, config);
    const tiktokUserIds =
        posts.data?.pages.map((page) => {
            const ids = page.results.map((p) => p.tiktok_details?.account_id).filter(isNotNullOrUndefined);
            return uniq(ids);
        }) ?? [];

    const userStatsQueries = useTikTokUserStatsCacheByIds(tiktokUserIds);
    const userStatsCache = uniqBy(
        userStatsQueries.flatMap((q) => q.data?.results ?? []),
        'user_id'
    );

    return {
        ...posts,
        userStatsCache,
    };
}
